import binderTemplateQueryReducer from 'complionAdmin/reducers/binderTemplateQuery';
import delegationOfAuthorityConfigurationReducer from 'complionAdmin/reducers/delegationOfAuthorityConfiguration';
import indexDocumentReducer from 'indexDocuments/reducers';
import institutionalAdminReducer from 'institutionalAdmin/reducers';

import binderReducer from 'binder/reducers';
import loginReducer from 'common/reducers/login';
import applicationFormReducer from 'forms/reducers';
import overviewReducer from 'overview/reducers';
import studyEventsReducer from 'pages/events/reducers/events';
import filesReducer from 'pages/files/reducers/files';
import permissionsReducer from 'pages/permissions/reducers/permissions';
import studyReducers from 'pages/study/reducers';
import processflowReducer from 'processflow/reducers';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import workflowReducer from 'workflow/reducers';

import apiConfigurationReducer from 'common/reducers/apiConfiguration';
import applicationContainerReducer from 'common/reducers/applicationContainer';
import applicationHeaderReducers from 'common/reducers/applicationHeader';
import applicationMessages from 'common/reducers/applicationMessages';
import applicationMessagesReducer from 'common/reducers/applicationMessages';
import dataSourcesReducer from 'common/reducers/dataSources';
import eventTypes from 'common/reducers/eventTypes';
import fileSortingOptionsReducer from 'common/reducers/fileSortingOptions';
import fileUploadReducer from 'common/reducers/fileUpload';
import pinnedBinderReducer from 'common/reducers/pinnedBinderToggle';
import searchContainerReducer from 'common/reducers/searchContainerReducers';
import { composeReducers } from 'common/util/composeReducers';

import binderTaskReducer from 'pages/binder/reducers/binderReducer';
import binderValidationReducer from 'pages/binder/reducers/binderValidation';
import dataSourcesInstitutionalAdminReducer from 'pages/dataSource/reducers/dataSource';
import studyAuditLog from 'pages/delegationOfAuthority/reducers/studyAuditLog';
import studyDelegationsReducer from 'pages/delegationOfAuthority/reducers/studyDelegations';
import studyRolesReducer from 'pages/delegationOfAuthority/reducers/studyRoles';
import studySignaturesReducer from 'pages/delegationOfAuthority/reducers/studySignatures';
import studyTasksReducer from 'pages/delegationOfAuthority/reducers/studyTasks';
import studyTestamentReducer from 'pages/delegationOfAuthority/reducers/studyTestaments';
import reportReducer from 'pages/report/reducers/reportReducer';
import studyOverviewReducers from 'pages/studyOverview/reducers/study.js';
import studyExpectationsReducers from 'pages/studyOverview/reducers/studyExpectations';
import studySettingsReducers from 'pages/studyOverview/reducers/studySettings';
import studyTaskReducers from 'pages/studyOverview/reducers/tasks.js';
import studyRoles from 'complionAdmin/reducers/studyRoles';
import studyAuditLogV2 from 'pages/delegationOfAuthority/v2/reducers/studyAuditLogV2';
import studyDelegationsReducerV2 from 'pages/delegationOfAuthority/v2/reducers/studyDelegationsV2';
import studyRolesReducerV2 from 'pages/delegationOfAuthority/v2/reducers/studyRolesV2';
import studySignaturesReducerV2 from 'pages/delegationOfAuthority/v2/reducers/studySignaturesV2';
import studyTasksReducerV2 from 'pages/delegationOfAuthority/v2/reducers/studyTasksV2';
import studyTeam from 'pages/delegationOfAuthority/v2/reducers/studyTeam';

const reactRouterReduxCompatibilityReducer = function (state = {}, action) {
    const oldState = state.routing;
    const newState = routerReducer(oldState, action);

    if (newState === oldState) {
        return state;
    }

    return {
        ...state,
        routing: newState,
    };
};

const reduxFormReducer = function (state, action) {
    const oldState = state.form;
    const newState = formReducer(oldState, action);

    if (newState === oldState) {
        return state;
    }

    return {
        ...state,
        form: newState,
    };
};

export default composeReducers(
    reactRouterReduxCompatibilityReducer,
    reduxFormReducer,
    loginReducer,
    applicationMessagesReducer,
    institutionalAdminReducer,
    binderTemplateQueryReducer,
    overviewReducer,
    binderReducer,
    applicationMessages,
    fileUploadReducer,
    dataSourcesReducer,
    searchContainerReducer,
    pinnedBinderReducer,
    eventTypes,
    dataSourcesInstitutionalAdminReducer,
    filesReducer,
    fileSortingOptionsReducer,
    processflowReducer,
    indexDocumentReducer,
    applicationContainerReducer,
    applicationFormReducer,
    workflowReducer,
    applicationHeaderReducers,
    binderTaskReducer,
    studyTasksReducer,
    studyDelegationsReducer,
    studyRolesReducer,
    studySignaturesReducer,
    studyTestamentReducer,
    studyAuditLog,
    binderValidationReducer,
    reportReducer,
    studyReducers,
    studySettingsReducers,
    studyExpectationsReducers,
    studyEventsReducer,
    studyOverviewReducers,
    studyTaskReducers,
    permissionsReducer,
    apiConfigurationReducer,
    delegationOfAuthorityConfigurationReducer,
    studyRoles,
    studyAuditLogV2,
    studyDelegationsReducerV2,
    studyRolesReducerV2,
    studySignaturesReducerV2,
    studyTasksReducerV2,
    studyTeam
);
